// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collapsible-panel {
  display: flex;
  min-height: 0;
  min-width: 0;
  background-color: #f8f9fa;
}

.collapsible-panel--side {
  flex-direction: row;
  border-right: 1px solid #ddd;
}

.collapsible-panel--side:last-child {
  border-right: none;
}

.collapsible-panel--bottom {
  flex-direction: column;
  border-top: 1px solid #ddd;
}

.collapsible-panel--expanded.collapsible-panel--side {
  flex: 1 1;
}

.collapsible-panel--collapsed.collapsible-panel--side {
  flex: 0 0 36px;
}

.collapsible-panel--expanded.collapsible-panel--bottom {
  flex: 0 1 38%;
  min-height: 0;
  max-height: 45vh;
}

.collapsible-panel--collapsed.collapsible-panel--bottom {
  flex: 0 0 36px;
}

.collapsible-panel-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: none;
  background: #e9ecef;
  color: #495057;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  transition: background-color 0.15s ease;
}

.collapsible-panel-toggle:hover {
  background: #dee2e6;
  color: #212529;
}

.collapsible-panel--side .collapsible-panel-toggle {
  width: 36px;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  transform: rotate(180deg);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.collapsible-panel--bottom .collapsible-panel-toggle {
  width: 100%;
  height: 36px;
  flex-direction: row;
  font-size: 13px;
  font-weight: 600;
}

.collapsible-panel-toggle-icon {
  font-size: 14px;
  line-height: 1;
  flex-shrink: 0;
}

.collapsible-panel-content {
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.collapsible-panel--side .collapsible-panel-content {
  padding: 0;
}

.collapsible-panel--bottom .collapsible-panel-content {
  overflow: hidden;
}

.collapsible-panel-content--hidden {
  display: none;
}

.dermoscopy-panel-inner,
.main-content-inner,
.navigation-panel-inner {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.navigation-panel-inner {
  padding: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/CollapsiblePanel/CollapsiblePanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,SAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,UAAU;EACV,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".collapsible-panel {\n  display: flex;\n  min-height: 0;\n  min-width: 0;\n  background-color: #f8f9fa;\n}\n\n.collapsible-panel--side {\n  flex-direction: row;\n  border-right: 1px solid #ddd;\n}\n\n.collapsible-panel--side:last-child {\n  border-right: none;\n}\n\n.collapsible-panel--bottom {\n  flex-direction: column;\n  border-top: 1px solid #ddd;\n}\n\n.collapsible-panel--expanded.collapsible-panel--side {\n  flex: 1 1 0;\n}\n\n.collapsible-panel--collapsed.collapsible-panel--side {\n  flex: 0 0 36px;\n}\n\n.collapsible-panel--expanded.collapsible-panel--bottom {\n  flex: 0 1 38%;\n  min-height: 0;\n  max-height: 45vh;\n}\n\n.collapsible-panel--collapsed.collapsible-panel--bottom {\n  flex: 0 0 36px;\n}\n\n.collapsible-panel-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border: none;\n  background: #e9ecef;\n  color: #495057;\n  cursor: pointer;\n  padding: 0;\n  flex-shrink: 0;\n  transition: background-color 0.15s ease;\n}\n\n.collapsible-panel-toggle:hover {\n  background: #dee2e6;\n  color: #212529;\n}\n\n.collapsible-panel--side .collapsible-panel-toggle {\n  width: 36px;\n  writing-mode: vertical-rl;\n  text-orientation: mixed;\n  transform: rotate(180deg);\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n}\n\n.collapsible-panel--bottom .collapsible-panel-toggle {\n  width: 100%;\n  height: 36px;\n  flex-direction: row;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.collapsible-panel-toggle-icon {\n  font-size: 14px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.collapsible-panel-content {\n  flex: 1 1 0;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.collapsible-panel--side .collapsible-panel-content {\n  padding: 0;\n}\n\n.collapsible-panel--bottom .collapsible-panel-content {\n  overflow: hidden;\n}\n\n.collapsible-panel-content--hidden {\n  display: none;\n}\n\n.dermoscopy-panel-inner,\n.main-content-inner,\n.navigation-panel-inner {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.navigation-panel-inner {\n  padding: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
